import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import BcProtegeInstructions from './BcProtege/BcProtegeInstructions/BcProtegeInstructions';
import BcProtegeValidationError from './BcProtege/BcProtegeValidationError/BcProtegeValidationError';
import BcProtegeValidationLoading from './BcProtege/BcProtegeValidationLoading/BcProtegeValidationLoading';

import { SettingsActions } from '@portal/actions';
import Loading from '@portal/components/Loading/Loading';
import WebviewDocuments from '@portal/components/OnboardingWebviewDocuments/OnboardingWebviewDocuments';
import {
  onboarding,
  onboardingBcProtegeCheck,
  useColorInSidebarOnboarding,
} from '@portal/config/app.json';
import { KEYCLOAK_LOGIN_ENABLED } from '@portal/config/env';
import { getRouteStackPath } from '@portal/config/routes';
import { PageClass } from '@portal/enum/analytics';
import { useNavigation } from '@portal/hooks/useNavigation';
import useReduxState from '@portal/hooks/useReduxState';
import { sendEvent } from '@portal/services/firebase';
import { getItem } from '@portal/services/storage';
import { useLocation } from 'react-router';
import NotFound from '../NotFound/NotFound';
import ChangePassword from './ChangeCredentials/ChangePassword';
import ChangePin from './ChangeCredentials/ChangePin';
import IncognitoBrowser from './IncognitoBrowser/IncognitoBrowser';
import KeyCloakLogin from './KeycloakLogin/KeycloakLogin';
import Login from './Login/Login';
import MultiAccessSelection from './MultiAccessSelection/MultiAccessSelection';
import OpenAccount from './OpenAccount/OpenAccount';
import PasswordRecovery from './PasswordRecovery/PasswordRecovery';
import Register from './Register/Register';
import RegisterNumber from './RegisterNumber/RegisterNumber';
import RequestSms from './RequestSms/RequestSms';
import TokenChannelSelection from './TokenChannelSelection/TokenChannelSelection';

const AuthNavigationStack: React.FC = () => {
  const {
    auth: {
      authToken: { accessToken },
    },
    theme: { currentTheme },
  } = useReduxState();
  const navigate = useNavigation();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.AUTH,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    dispatch(SettingsActions.getSettings());
  }, [accessToken, dispatch, navigate]);

  return (
    <Switch>
      <Route path="/" exact>
        {KEYCLOAK_LOGIN_ENABLED ? <KeyCloakLogin /> : <Login />}
      </Route>
      <Route path="/selecionar-canal">
        <TokenChannelSelection />
      </Route>
      <Route path="/solicitar-sms">
        <RequestSms />
      </Route>
      <Route path="/recuperar-senha">
        <PasswordRecovery />
      </Route>
      <Route path="/recuperar-login">
        <PasswordRecovery />
      </Route>
      <Route path="/acesso-negado">
        <IncognitoBrowser />
      </Route>
      <Route path={getRouteStackPath('PROFILE', 'ACCOUNT_SELECTION')}>
        <MultiAccessSelection />
      </Route>
      <Route exact path="/trocar-credenciais/senha">
        <ChangePassword />
      </Route>
      <Route exact path="/trocar-credenciais/pin">
        <ChangePin />
      </Route>
      <Route path="/cadastrar-numero">
        <div className="auth-navigation-stack">
          <div className="auth-navigation-stack__content">
            <RegisterNumber />
          </div>
          <div
            className={
              useColorInSidebarOnboarding.usePrimaryColor
                ? 'auth-navigation-stack__empty-primary-color'
                : 'auth-navigation-stack__empty'
            }
          />
        </div>
      </Route>
      {onboarding.enabled ? (
        <Route path="/cadastrar">
          <Register />
        </Route>
      ) : null}
      {onboarding.enabled ? (
        <Route path="/abertura-de-conta">
          <div className="auth-navigation-stack">
            <div
              className={
                useColorInSidebarOnboarding.usePrimaryColor
                  ? 'auth-navigation-stack__empty-primary-color'
                  : 'auth-navigation-stack__empty-light'
              }
              style={{ background: currentTheme?.background }}
            />
            <div className="auth-navigation-stack__content">
              <OpenAccount />
            </div>
          </div>
        </Route>
      ) : null}
      {onboarding.enabled ? (
        <Route path="/documentos-celcoin">
          <WebviewDocuments />
        </Route>
      ) : null}
      {onboarding.enabled && onboardingBcProtegeCheck ? (
        <Route path="/bc-protege/validacao">
          <BcProtegeValidationLoading />
        </Route>
      ) : null}
      {onboarding.enabled && onboardingBcProtegeCheck ? (
        <Route path="/bc-protege/erro">
          <BcProtegeValidationError />
        </Route>
      ) : null}
      {onboarding.enabled && onboardingBcProtegeCheck ? (
        <Route path="/bc-protege/instrucoes">
          <BcProtegeInstructions />
        </Route>
      ) : null}
      <Route>{getItem('session-token') ? <Loading /> : <NotFound />}</Route>
    </Switch>
  );
};

export default AuthNavigationStack;
